















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import GroupButton from '@/modules/shared/components/group-button.component.vue';
import NationalPosition from '@/modules/purchase/views/national-position.view.vue';
import GeneralRanking from '@/modules/purchase/views/general-ranking.view.vue';
import GeneralComparision from '@/modules/purchase/views/general-comparision.view.vue';
import PersonalSales from '@/modules/purchase/views/personal-sales.view.vue';

import textDecorate from '@/modules/shared/directives/text-decorate.directive.ts';


const NationalPositionId = 1;
const GeneralRankingId = 2;
const GeneralComparisionId = 3;
const PersonalSalesId = 4;

@Component({
    components: {
        GroupButton,
        NationalPosition,
        GeneralRanking,
        GeneralComparision,
        PersonalSales,
    },
    directives: {
        textDecorate,
    },
    computed: {
        ...mapGetters({
            fullName: 'getProfileFullName',
        }),
    },
})
export default class Sales extends Vue {
    private literals =  {
        title: 'ECO Ventas',
    };
    private options: any[] = [{
        id: NationalPositionId,
        value: 'Posición Nacional',
    }, {
        id: GeneralRankingId,
        value: 'Clasificación general',
    }, {
        id: GeneralComparisionId,
        value: 'Comparativo general',
    }, {
        id: PersonalSalesId,
        value: 'Ventas personales',
    }];
    private option = this.options[0];


    private fullName!: string;


    get subtitle() {
        return `Perfil comercial de ${this.fullName}`;
    }

    get showNationalPosition() {
        return this.option.id === NationalPositionId;
    }

    get showGeneralRanking() {
        return this.option.id === GeneralRankingId;
    }

    get showGeneralComparision() {
        return this.option.id === GeneralComparisionId;
    }

    get showPersonalSales() {
        return this.option.id === PersonalSalesId;
    }
}
